import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType,
    Widget,
} from '@appblocks/codegeneration/types';
import BaseWidget, { sizes } from '@appblocks/codegeneration/Widgets/BaseWidget';

export default class SwitchWidget extends BaseWidget {
    constructor() {
        super();
        this.name = 'Switch Widget';
        this.id = 'switch_widget';
        this.minW = sizes[this.id].minW;
        this.minH = sizes[this.id].minH;

        const settings = this.getWidgetSettings(['VARIABLE', 'LABEL', 'OFF_VALUE', 'ON_VALUE', 'OFF_LABEL', 'ON_LABEL']);

        this.settings = this.settings.concat(settings);
    }
}
